import { Button, Card, Checkbox, Dropdown, Spinner, Table } from 'flowbite-react';
import React from 'react';
import { FaArrowDown, FaArrowUp, FaEllipsisH } from 'react-icons/fa';
import * as styles from './customTable.styles';
import logo from '../../assets/Ideos.png'

interface TableProps {
    data?: any[];
    headings?: any[];
    actions?: string[],
    emptyMessage?: string,
    loading?: boolean,
    parentClass?: string
}

const CustomTable = ({ headings, data, actions, emptyMessage, loading, parentClass = 'overflow-x-auto' }: TableProps) => {



    return (
        <div className={'overflow-x-auto'}>
            <Table className='table-auto w-full'>
                <Table.Head className={styles.head}>
                    <Table.HeadCell className={styles.headCell}><Checkbox /></Table.HeadCell>
                    {headings?.map((heading, index) => (
                        <Table.HeadCell key={index} className={`${styles.headCell}`}>
                            <div className='flex items-center gap-1'>
                                {heading.Header}
                                <div className={styles.arrowIcons}>
                                    <FaArrowDown size="10" /><FaArrowUp size="10" />
                                </div>
                            </div>
                        </Table.HeadCell>
                    ))}
                </Table.Head>
                <Table.Body>
                    {
                        loading ? (
                            <Table.Row>
                                <Table.Cell colSpan={headings && headings?.length + 1} className="text-center">
                                    {/* <div className=" inset-0 z-50 flex items-center justify-center ">
                                        <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                                    </div>                                 */}
                                </Table.Cell>
                            </Table.Row>
                        ) :
                            data?.length === 0 && headings ? (
                                <Table.Row>
                                    <Table.Cell colSpan={headings?.length + 1} className={styles.emptyRow}>
                                        <div className={styles.emptyCell}>
                                            <p>{emptyMessage ? emptyMessage : "No record yet"}</p>
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                            ) : (

                                data?.map((row, rowIndex) => (
                                    <Table.Row key={rowIndex} className={styles.bodyRow}>
                                        <Table.Cell className={styles.bodyCell}><Checkbox /></Table.Cell>
                                        {headings?.map((heading, cellIndex) => (
                                            <Table.Cell key={cellIndex} className={styles.bodyCell}>
                                                {typeof row[heading.accessor] === 'object' && row[heading.accessor] !== null && row[heading.accessor].$$typeof
                                                    ? row[heading.accessor]
                                                    : row[heading.accessor] !== null && row[heading.accessor] !== undefined
                                                        ? row[heading.accessor]
                                                        : 'N/A'}
                                            </Table.Cell>
                                        ))}
                                    </Table.Row>
                                ))
                            )}
                </Table.Body>
            </Table>
        </div>

    );
}

export default CustomTable;
